import 'ui-core/components/article-actions-bar/js/article-action-bar';

(function () {
    const articleActionsbar = UX.articleActionsbar;

    articleActionsbar.checkedCNT = function () {
        return Object.values(articleActionsbar.checkboxes).filter(el => el.checked).length;
    };

    articleActionsbar.controls = () => {
        if (config.enableArticleActionbarSelectAll) {
            articleActionsbar.selectAllBox.addEventListener('click', function () {
                const isChecked = this.checked;
                articleActionsbar.checkboxes.forEach(item => (item.checked = isChecked));
                articleActionsbar.hideBtnsOrDisableSelect();
            });
        }

        articleActionsbar.checkboxes.forEach(elem => {
            elem.addEventListener('click', () => {
                articleActionsbar.selectAllBox.checked = articleActionsbar.allItemsSelected();
                articleActionsbar.hideBtnsOrDisableSelect();
            });
        });

        articleActionsbar.btns.forEach(elem => {
            if (!(articleActionsbar.bulkAction.length > 0)) {
                elem.addEventListener('click', function (e) {
                    const _this = this;
                    if (articleActionsbar.checkedCNT() == 0) {
                        articleActionsbar.checkboxes.forEach(item => (item.checked = true));
                        articleActionsbar.selectAllBox.checked = true;
                    }
                    e.preventDefault();
                    if (!_this.hasAttribute('data-toggle') && _this.nodeName !== 'OPTION') {
                        articleActionsbar.form.action = _this.href;
                        articleActionsbar.form.submit();
                    }
                });
            } else {
                articleActionsbar.bulkAction.addEventListener('change', function (e) {
                    const _this = this;
                    if (!articleActionsbar.form.length || !articleActionsbar.hasSelectedItems()) {
                        return;
                    }
                    articleActionsbar.form.action = _this.value;
                    articleActionsbar.form.submit();
                });
            }
        });
    };
})();
